"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useRecommendationStepper = require("../../hooks/recommendation/useRecommendationStepper");
var _constants = require("../../utils/constants");
var _UpsellHeader = _interopRequireDefault(require("../Upsell/UpsellHeader"));
var _RecommendationHeader = _interopRequireDefault(require("./RecommendationHeader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RecommendationHeaderFactory = function RecommendationHeaderFactory() {
  var _useRecommendationSte = (0, _useRecommendationStepper.useRecommendationStepper)(),
    currentStepObject = _useRecommendationSte.currentStepObject;
  switch (currentStepObject === null || currentStepObject === void 0 ? void 0 : currentStepObject.stepType) {
    case _constants.STEP_TYPES.HANDSET:
    case _constants.STEP_TYPES.AIRTIME_PLAN:
    case _constants.STEP_TYPES.PLAN:
    case _constants.STEP_TYPES.BROADBAND:
      return /*#__PURE__*/_react.default.createElement(_RecommendationHeader.default, null);
    case _constants.STEP_TYPES.UPSELL:
      return /*#__PURE__*/_react.default.createElement(_UpsellHeader.default, null);
    default:
      return /*#__PURE__*/_react.default.createElement(_RecommendationHeader.default, null);
  }
};
var _default = RecommendationHeaderFactory;
exports.default = _default;